import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const [inInquiry, setInInquiry] = useState(false);

  useEffect(() => {
    const inquiry = document.getElementById("inquiry");
    const hero = document.getElementById("top");

    const onScroll = () => {
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 0;
      // Show after user scrolls past hero
      setVisible(heroBottom < 40);

      if (inquiry) {
        const r = inquiry.getBoundingClientRect();
        // Hide when inquiry form is on screen (user has arrived)
        setInInquiry(r.top < window.innerHeight * 0.6 && r.bottom > 100);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const show = visible && !inInquiry;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
          className="md:hidden fixed bottom-0 inset-x-0 z-40 px-4 pb-4 pt-3 bg-gradient-to-t from-[#F9F6F0] via-[#F9F6F0]/95 to-transparent pointer-events-none"
          data-testid="sticky-mobile-cta"
        >
          <a
            href="#inquiry"
            data-testid="sticky-mobile-cta-btn"
            className="pointer-events-auto flex items-center justify-center gap-2 w-full bg-[#1A1A1A] text-[#F9F6F0] py-4 rounded-full eyebrow text-[11px] shadow-[0_16px_40px_-12px_rgba(0,0,0,0.5)]"
          >
            Begin an Inquiry <ArrowUpRight size={14} strokeWidth={1.5} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
